var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scontrino",staticClass:"carrello",class:{ reso: _vm.isReso }},_vm._l((_vm.righeScontrino),function(riga,index){return _c('riga-carrello',{key:index,attrs:{"riga":riga,"reso":_vm.reso}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }